import { cardAnatomy } from '@chakra-ui/react/anatomy';
import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

const markdownCardSlotRecipe = defineSlotRecipe({
  className: 'markdown-card',
  slots: [...cardAnatomy.keys(), 'iconBar', 'content', 'gradient', 'footerButtons'],
  base: {
    root: {
      backgroundColor: 'background/primary',
      overflow: 'hidden',
    },
    iconBar: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
      paddingInline: '8',
      paddingBlock: '12',
      flexShrink: 0,
      borderInlineEnd: '1px solid',
    },
    content: {
      flex: 1,
      paddingInlineStart: '16',
      paddingInlineEnd: '24',
      paddingBlockStart: '24',
      minWidth: 0,
      position: 'relative',
    },
    gradient: {
      background: 'linear-gradient(to top, {colors.neutral.100} 12.5%, transparent)',
      bottom: 0,
      height: '128',
      insetInline: 0,
      pointerEvents: 'none',
      position: 'absolute',
    },
    footerButtons: {
      justifyContent: 'flex-end',
      paddingBlockEnd: '16',
      paddingBlockStart: '16',
      paddingInlineEnd: '8',
    },
  },
  variants: {
    status: {
      info: {
        iconBar: {
          backgroundColor: 'background/secondary',
          borderColor: 'border/regular',
          color: 'icon/secondary',
        },
        root: {
          borderColor: 'border/regular',
        },
      },
      success: {
        iconBar: {
          backgroundColor: 'status/success/bg',
          borderColor: 'status/success/border',
          color: 'color/green/base',
        },
        root: {
          borderColor: 'status/success/border',
        },
      },
      warning: {
        iconBar: {
          backgroundColor: 'status/warning/bg',
          borderColor: 'status/warning/border',
          color: 'color/yellow/base',
        },
        root: {
          borderColor: 'status/warning/border',
        },
      },
      critical: {
        iconBar: {
          backgroundColor: 'status/critical/bg',
          borderColor: 'status/critical/border',
          color: 'color/red/base',
        },
        root: {
          borderColor: 'status/critical/border',
        },
      },
    },
  },
  defaultVariants: {
    status: 'info',
  },
});

export default markdownCardSlotRecipe;
